module.exports = __webpack_public_path__ + "static/media/srsbzns.83717b06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/portfolios/srsbzns.jpg
// module id = 290
// module chunks = 0